import { render } from "./ProjectPreviewList.vue?vue&type=template&id=70c47c8e&scoped=true&ts=true"
import script from "./ProjectPreviewList.vue?vue&type=script&lang=ts"
export * from "./ProjectPreviewList.vue?vue&type=script&lang=ts"

import "./ProjectPreviewList.vue?vue&type=style&index=0&id=70c47c8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c47c8e"]])

export default __exports__